<template>
    <div>
        <v-list-item class="bordered rounded" @click="detailsDialog = true" v-ripple="false">
            <v-list-item-avatar>
                <v-icon color="primary" size="28">mdi-clock</v-icon>
            </v-list-item-avatar>
    
            <v-list-item-content>
                <v-list-item-title>{{ classData.enrollment.course.name }}</v-list-item-title>
                <v-list-item-subtitle>
                    <span v-if="isTeacher">{{ classData.enrollment.student.name }}</span>
                    <span v-else>{{ classData.enrollment.teacher.name }}</span>
                </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content :style="phoneOnly ? 'flex-basis: 25%;' : ''">
                
                <div class="details-text text--text mb-1" style="font-weight: 500">
                    <v-icon color="text" size="15" class="me-1">mdi-calendar</v-icon> 
                    <span>{{ classDateFormated }}</span>
                </div>
                <div class="d-flex align-center mt-1">
                    <div class="primary--text">{{startTime}}</div>
                    <div class="font-weight-bold mx-2">:</div>
                    <div class="primary--text">{{endTime}}</div>
                </div>
            </v-list-item-content>
            <v-list-item-icon v-if="pcOnly">
                <ClassListItemBadges :classData="classData" />
            </v-list-item-icon>
        </v-list-item>
        <v-dialog transition="slide-y-transition" v-model="detailsDialog" :fullscreen="phoneOnly" :fluid="phoneOnly" full max-width="375" overlay-color="#000000">
            <class-card :class-data="classData" @close="detailsDialog = false" :reloading="reloading" />
        </v-dialog>
    </div>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import ClassCard from '@/components/custom/class-card'
import ClassListItemBadges from './class-list-item-badges.vue'


export default {
    components: {ClassCard, ClassListItemBadges},
    data(){
        return {
            detailsDialog: false,
            
            intervalid: null,
            timeAgo: '',
        }
    },
    props: {
        classData: {},
        reloading: {type: Boolean, default: false}
    },
    computed: {
        running(){
            return this.classData.status === 'running';
        },
        startTime(){
            // const d = new Date(this.classData.start);
            // const timeString = d.toLocaleTimeString();
            // const times = timeString.split(' ')[0].split(':');
            // return `${times[0]}:${times[1]} ${timeString.split(' ')[1]}`

            const t = new Date(this.classData.start);
            return this.formatTime(t);
        },
        endTime(){
            const t = new Date(this.classData.end);
            return this.formatTime(t);
        },
        classDateFormated(){
            const t = new Date(this.classData.start)
            const options = { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric' };
            return t.toLocaleDateString("en-US", options);
        },
        ...GlobalComputed
    },
    methods: {
        ...GlobalMethods,
        formatTime(t, isTimestamp=false){
            if (isTimestamp){
                t = new Date(t);
            }
            let hours = t.getHours(), 
                minutes = t.getMinutes() + '', 
                ampm = 'AM';

            if(hours > 11){
                hours = hours - 12;
                ampm = 'PM';
            }

            if(hours == 0) hours = 12;
            if(minutes.length == 1) minutes = '0' + minutes;

            return `${hours}:${minutes} ${ampm}`;
        },

        timeAgoFormat(time) {
            const self = this;
            self.timeAgo = self.timeSince(time, true);

            // update time every 1s
            this.intervalid = setInterval(function () {
                self.timeAgo = self.timeSince(time, true);
            }, 1000);
        },
        backButtonHandler(){
            if (this.detailsDialog){
                this.detailsDialog = false;
            }else{
                this.$router.go(-1);
            }
        }
    },
    watch: {
        classData(){
            this.timeAgoFormat(this.classData.start);
        }
    },
    mounted(){
        this.timeAgoFormat(this.classData.start);

        if (this.capRunning){
            document.addEventListener('backbuttonclicked', this.backButtonHandler)
        }
    },
    beforeDestroy(){
        if (this.intervalid){
            window.clearInterval(this.intervalid);
        }

        if (this.capRunning){
            document.removeEventListener('backbuttonclicked', this.backButtonHandler)
        }
    }
};
</script>
